import React from "react";
import { Col, Row, Button  } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Typewriter } from "react-simple-typewriter";
import ParticlesBackground from "../components/ParticlesBackground";

function Home() {
  return (
    <div  >
      <div className="home-section">
          <ParticlesBackground />
       <div>
       <div className="content">
          <span className="hello">Hi I'm</span>
          <h1>Dipta </h1>
          
          <p>
            I'm  <br/>
            <span/>
            <span className="type-text">
              <Typewriter
                loop
                cursor
                cursorStyle="|"
                typeSpeed={50}
                deleteSpeed={80}
                delaySpeed={1500}
                words={[
                  "Jr. Web developer",
                  "MERN Developer ",
                  
      
                ]}
              />
            </span>
          </p>
        </div>
        <div
          className=" buttons container-fluid d-flex justify-content-center"
          style={{
            width: "320px",
            position: "relative",
            left: "-25px",
            top: "30px",
          }}
        >
          <Row>
            <Col>
              <Button as={Link} to="/mywork" variant="outline-light">
                My Work
              </Button>
            </Col>
            
            <Col>
              <Button variant="outline-warning">
              <a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1-V78F9dbL7_m4BcK2r0ZLuS_Hd2L4DYk/view?usp=sharing' download="Dipta Chowdhury.pdf">MyResume </a>
              </Button>
            </Col>
            
          </Row>
        </div>
       </div>
      </div>
    </div>
  );
}

export default Home;
